import { useId } from 'react';
import { Button, Card, CardContent, CardTitle } from '@/shared/components';
import { useTemplatePreview } from '../../hooks/useTemplatePreview';
import { TemplatePreviewModal } from '../TemplatePreviewModal';

interface Props {
  templateId: string;
  publishedVersionId: string;
}

export function LivePreviewCard({ templateId, publishedVersionId }: Props) {
  const headingId = useId();
  const preview = useTemplatePreview(templateId);

  return (
    <Card ariaLabelledBy={headingId}>
      <CardContent className="space-y-3 py-5">
        <CardTitle size="sm" id={headingId}>
          Live document
        </CardTitle>
        <p className="text-sm text-mp-muted">See the published version rendered with sample data.</p>
        <Button
          type="button"
          variant="neutral" appearance="outline"
          size="sm"
          className="w-full"
          onClick={() => preview.open({ versionId: publishedVersionId })}
        >
          Preview with sample data
        </Button>
        <TemplatePreviewModal
          isOpen={preview.isOpen}
          onClose={preview.close}
          isLoading={preview.isLoading}
          error={preview.error}
          preview={preview.preview}
        />
      </CardContent>
    </Card>
  );
}
